import React from "react";

interface SpinnerProps {
  size?: "small" | "large";
}

const Spinner = ({size}: SpinnerProps) => {
  const radius = size === "small" ? 10 : 20;

  return (
    <svg className="spinner" viewBox="0 0 50 50">
      <circle className="path" cx="25" cy="25" r={radius} fill="none" strokeWidth="5"></circle>
    </svg>
  );
};

export default Spinner;
